// Conventions used in values (rendered by <RichText />):
//   "\n"      -> line break
//   [[text]]  -> highlighted span (colour is chosen by the component)
//   __text__  -> italic

const en = {
  meta: {
    title:
      "P.U.R.B.A. | Earth's Early History Exhibition – Bogor Botanical Gardens",
    description:
      "P.U.R.B.A. is an exhibition tracing the footprints of ancient life, from prehistoric seas and dinosaurs to early humans. Coming soon to Bogor Botanical Gardens.",
    imageAlt:
      "An explorer child with a magnifying glass at the mouth of an ancient cave, facing a volcano and a dinosaur, with the text P.U.R.B.A. Pameran Universum Riwayat Bumi Awal",
    locale: "en_US",
  },
  // Language-specific image files (artwork with text baked into it)
  images: {
    timeline: "/assets/images/timeline-eng.png",
  },
  alt: {
    partners:
      "Partner logos: Kebun Raya Bogor, Dyandra Global, and Life Science Studio",
    aboutImage:
      "Mossy dinosaur skull on a rock, surrounded by leaf and fossil illustrations",
    identityImage:
      "Early human skull in mossy rock beside the silhouette of an early human holding a spear",
    timeline:
      "40+ ancient species, 8 edutainment zones, 1 million years of Earth's story",
    logoPurba: "P.U.R.B.A. logo",
    logoKebunRaya: "Kebun Raya logo",
    logoDyandra: "Dyandra Global logo",
    logoLifeScience: "Life Science Studio logo",
  },
  navbar: {
    subtitle: "PAMERAN UNIVERSUM\nRIWAYAT BUMI AWAL",
    languageLabel: "Select language",
  },
  hero: {
    title: "EXPLORATION\nIS ABOUT TO\n[[BEGIN]]",
    subtitle:
      "A journey tracing the footprints of ancient\nlife from prehistoric seas and dinosaurs\nto early humans who once lived on the very\nsame land we live on today.",
    comingSoon: "Coming Soon",
    venue: "Bogor Botanical Gardens",
    ticket: "Buy Ticket"
  },
  about: {
    label: "ABOUT THE EXHIBITION",
    title: "An adventure\ninto the [[past]]\nof ancient Earth!",
    paragraph1:
      "Imagine the Earth beneath your feet millions of years ago. No cities yet. No roads yet. Only ancient forests, active volcanoes, shallow seas, and the creatures that shaped the beginning of life.",
    paragraph2:
      "P.U.R.B.A. invites visitors to explore the evolution of the Earth through fossils, reconstructions of ancient creatures, and immersive experiences that connect science, history, and imagination.",
  },
  identity: {
    label: "NUSANTARA IDENTITY",
    title: "OUR STORY\nBEGINS [[HERE]]!",
    paragraph1:
      "The Nusantara holds a unique story of evolution. From __Homo floresiensis__ in Flores and traces of early humans in Java, to endemic species that survive to this day.",
    paragraph2:
      "This exhibition presents a journey into our origins, not only as humans, but also as part of an ever-changing Earth.",
  },
  visit: {
    label: "PLAN YOUR VISIT",
    title: "Meet Us\nAt Bogor\nBotanical Gardens",
    description:
      "P.U.R.B.A. is held at the Melchior Building, Bogor Botanical Gardens, set in a green space that has witnessed the journey of science and history in Indonesia.",
    address:
      "Melchior Building\nJl. Ir. H. Juanda No. 13\nBogor Tengah, Kota Bogor\nJawa Barat 16122",
    hours:
      "Opening Hours\nCOMING SOON!\nThe detailed schedule will be\nannounced via Instagram",
    audience:
      "For Everyone\nStudents, families,\nand science lovers\nare welcome!",
    mapTitle: "Location map on Google Maps",
  },
  footer: {
    helpTitle: "Need help?\nWe're here for you",
    helpText: "Reach out to us through any\nof the channels below.",
    hotline: "Hotline:",
    email: "Email:",
    connect: "Connect with us",
    handle: "Riwayat\nPurba",
  },
  comingSoon: {
    title: "COMING [[SOON]]",
    description:
      "The learning content for this item is being prepared. Stay tuned!",
  },
  notFound: {
    code: "404",
    title: "PAGE [[NOT FOUND]]",
    description:
      "Looks like you wandered off into the ancient past. The page you are looking for doesn't exist or has moved.",
    button: "Back to Homepage",
  },
};

export default en;
